import datapoints from './datapoints';
import moveMailListRows from './move/moveMailListRows';
import { TableView } from 'owa-mail-list-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { select } from 'satcheljs/lib/legacy';
import { ActionSource, createLegacyActionWithDatapoint } from 'owa-analytics-actions';

export interface ArchiveMailListRowsFromTableState {
    archiveFolderId: string;
}

/**
 * Archive mail list rows from table
 * @param rowKeys the instance keys of the rows to archive
 * @param tableView the table view that contains the rows to archive
 * @param actionSource the action source that triggers the archive action
 */
export default select<ArchiveMailListRowsFromTableState>({
    archiveFolderId: () => getUserConfiguration().UserOptions.ArchiveFolderId,
})(
    createLegacyActionWithDatapoint('archiveMailListRowsFromTable', datapoints.archiveMailListRows)(
        async function archiveMailListRowsFromTable(
            rowKeys: string[],
            tableView: TableView,
            actionSource: ActionSource,
            state?: ArchiveMailListRowsFromTableState
        ) {
            if (state.archiveFolderId) {
                await moveMailListRows(rowKeys, state.archiveFolderId, tableView.id);
            } else {
                // For new accounts and the existing accounts which have not setup the archive folder
                // the archive folder should get created as a default folder.
                throw new Error('Archive folder id should always be set');
            }
        }
    )
);
